<template>
  <div>
    <div
      class="responsive-print"
      :id="field.temp_prop.paper_size==0?'inch3-thermal-print-page':'inch4-thermal-print-page'"
      style="background: white;display: block;margin: 0 auto;box-shadow: 0 0 0.2cm rgba(0, 0, 0, 0.13);"
    >
      <div
        class="print-template"
        :style="{'background':field.temp_prop.bg_color.show==1?field.temp_prop.bg_color.value.hex:'#fff'}"
      >
        <!--Header Block -->
        <div class="invoice-header-block" :style="{'height':field.temp_prop.margin_top+'in'}"></div>
        <!-- Body -->
        <div
          class="invoice-content-layout"
          :style="{'padding-right':field.temp_prop.margin_right+'in','padding-left':field.temp_prop.margin_left+'in'}"
        >
          <!-- Organisation Logo -->
          <div v-if="field.header_prop.show_logo" class="text-center" style="display:block">
            <img
              v-if="field.header_prop.show_logo&&imageSrc!=''"
              :src="imageSrc"
              :style="{'width':field.header_prop.logo_width+'px'}"
              style="max-width:240px;max-height:146.44px;;height:auto;"
            />
            <img
              v-if="field.header_prop.show_logo&&imageSrc==''"
              src="@/assets/logo/Shanki-logo.png"
              :style="{'width':field.header_prop.logo_width+'px'}"
              style="max-width:240px;max-height:146.44px;;height:auto;"
            />
          </div>
          <!-- Organisation details -->
          <div class="inch3-details-view text-center">
            <!-- Organisation Name -->
            <h5
              v-if="field.header_prop.show_org_name"
              style="display:block;margin-bottom:3px;margin-top:5px;"
              :style="{'color':field.header_prop.org_name_color.hex,'font-size':field.header_prop.org_name_size+'pt'}"
            >Shanki Systems India Pvt Ltd</h5>
            <!-- Organisation address -->
            <div class="thermal-custom-invoice-address">
              <p
                :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                v-if="field.header_prop.show_org_addr"
              >
                <span>JK Towers 5/4 Moonlight Garden</span>
                <span style="padding-left:3px">Kalapatti Road Coimbatore</span>
                <span style="padding-left:3px">TamilNadu</span>
                <span style="padding-left:3px">India 641048</span>
              </p>

              <p>
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >GSTIN :</span>
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >12ASDF12345A1Z0</span>
              </p>
              <!-- <p>
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >Mail:</span>
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >admin@shanki.com</span>
              </p>-->

              <p v-if="field.header_prop.phone" style="word-break: break-word !important;">
                <span
                  :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{field.header_prop.phone}} :</span>
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >76639488488</span>
              </p>
              <!-- <p>
                <span
                  :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{field.header_prop.fax}} :</span>
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >ASDWERT</span>
              </p>-->
              <template>
                <p
                  v-if="field.header_prop.doc_place_supply.show"
                  style="word-break: break-word !important;"
                >
                  <span
                    :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{field.header_prop.doc_place_supply.label}} :</span>
                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >Coimbatore</span>
                </p>

                <!-- <p>Mail: admin@shanki.com</p> -->
                <p
                  v-if="field.header_prop.doc_sales_person.show"
                  style="margin-bottom:5px !important;word-break: break-word !important"
                >
                  <span
                    :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{field.header_prop.doc_sales_person.label}}:</span>
                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >John Smith</span>
                </p>
              </template>
            </div>

            <!-- Document title -->
            <div
              v-if="field.header_prop.show_doc_title"
              class="document-title"
              style="display:block"
            >
              <h6 style="margin-bottom:5px !important;">{{field.header_prop.doc_title}}</h6>
            </div>
            <!-- Invoice details -->
            <div
              class="thermal-invoice-details"
              :style="{'border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 '}"
            >
              <p
                style="margin-bottom:0px !important;display:block;word-break: break-word !important;"
                v-if="field.header_prop.num_field.show"
              >
                <span
                  :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >
                  <!-- {{field.menu_id==1?'Invoice#':field.menu_id==2?'Quotation#':'Credit#'}} : -->
                  {{field.header_prop.num_field.label}} :
                </span>

                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  style="font-weight:700 !important;"
                >{{field.menu_id==1?$AppDetails.financial_year+'/INV14468':field.menu_id==2?$AppDetails.financial_year+'/QOT10005':$AppDetails.financial_year+'/CN10005'}}</span>
              </p>

              <template v-if="field.menu_id==1||field.menu_id==3">
                <p
                  style="margin-bottom:0px !important;display:block;word-break: break-word !important;"
                  v-if="field.header_prop.doc_date.show"
                >
                  <span
                    :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{field.header_prop.doc_date.label}} :</span>
                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{getDateFormat(new Date())}}</span>
                </p>
              </template>
              <p
                style="margin-bottom:5px !important;display:block;word-break: break-word !important;"
                v-if="field.header_prop.cus_label.show"
              >
                <span
                  :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{field.header_prop.cus_label.label}} :</span>
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >Shanki systems</span>
              </p>
              <p
                style="margin-bottom:5px !important;display:block;word-break: break-word !important;"
                v-if="field.header_prop.cus_ph_label.show"
              >
                <span
                  :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{field.header_prop.cus_ph_label.label}} :</span>
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >9878878967</span>
              </p>
            </div>
          </div>

          <!-- Organisation details -->
          <div class="inch4-details-view">
            <!-- Organisation Name -->
            <h5
              v-if="field.header_prop.show_org_name"
              style="display:block;margin-bottom:3px;margin-top:5px;"
              class="text-center"
              :style="{'color':field.header_prop.org_name_color.hex,'font-size':field.header_prop.org_name_size+'pt'}"
            >Shanki Systems India Pvt Ltd</h5>
            <!-- Organisation address -->
            <div class="thermal-custom-invoice-address text-center" style="display:flow-root">
              <p
                :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                v-if="field.header_prop.show_org_addr"
              >
                <span>JK Towers 5/4 Moonlight Garden</span>
                <span style="padding-left:3px">Kalapatti Road Coimbatore</span>
                <span style="padding-left:3px">TamilNadu</span>
                <span style="padding-left:3px">India 641048</span>
              </p>
              <div v-if="field.menu_id!=3" class="float-left" style="margin-top:5px !important">
                <p
                  class="text-left"
                  v-if="field.header_prop.doc_place_supply.show"
                  style="word-break: break-word !important;"
                >
                  <span
                    :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{field.header_prop.doc_place_supply.label}} :</span>
                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >Coimbatore</span>
                </p>

                <p
                  class="text-left"
                  v-if="field.header_prop.doc_sales_person.show"
                  style="margin-bottom:5px !important;word-break: break-word !important;"
                >{{field.header_prop.doc_sales_person.label}} : John Smith</p>
              </div>
              <div class="float-right" style="margin-top:5px !important">
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >GSTIN :</span>
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >12ASDF12345A1Z0</span>
                <p>
                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >Mail:</span>
                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >admin@shanki.com</span>
                </p>
                <p
                  class="text-right"
                  style="margin-bottom:5px !important;word-break: break-word !important;"
                >
                  <span
                    :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{field.header_prop.phone}} :</span>
                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >76639488488</span>
                </p>
                <p
                  class="text-right"
                  style="margin-bottom:5px !important;word-break: break-word !important;"
                >
                  <span
                    :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{field.header_prop.fax}} :</span>
                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >ASDWERT</span>
                </p>
              </div>
            </div>

            <!-- Document title -->
            <div
              class="document-title text-center"
              v-if="field.header_prop.show_doc_title"
              style="display:flow-root"
            >
              <h6 style="margin-bottom:5px !important;">{{field.header_prop.doc_title}}</h6>
            </div>
            <!-- Invoice details -->
            <div
              class="thermal-invoice-details"
              :style="{'border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 '}"
            >
              <p
                style="margin-bottom:0px !important;display:block;word-break: break-word !important;"
                class="text-center"
                v-if="field.header_prop.num_field.show"
              >
                <!-- {{field.menu_id==1?'Invoice#':field.menu_id==2?'Quotation#':'Credit#'}} : -->
                <span
                  :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >
                  <!-- {{field.menu_id==1?'Invoice#':field.menu_id==2?'Quotation#':'Credit#'}} : -->
                  {{field.header_prop.num_field.label}}
                </span>
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  style="font-weight:700 !important;"
                >{{field.menu_id==1?$AppDetails.financial_year+'/INV14468':field.menu_id==2?$AppDetails.financial_year+'/QOT10005':$AppDetails.financial_year+'/CN10005'}}</span>
              </p>

              <p
                style="margin-bottom:5px !important;margin-top:5px !important;display: flow-root;word-break: break-word !important;"
              >
                <span class="text-right float-right" v-if="field.header_prop.doc_date.show">
                  <span
                    :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{field.header_prop.doc_date.label}} :</span>
                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{getDateFormat(new Date())}}</span>
                </span>
                <span class="text-left" v-if="field.header_prop.cus_label.show">
                  <span
                    :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{field.header_prop.cus_label.label}} :</span>
                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >Shanki systems</span>
                </span>
                <span
                  class="text-left"
                  style="display:block"
                  v-if="field.header_prop.cus_ph_label.show"
                >
                  <span
                    :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{field.header_prop.cus_ph_label.label}} :</span>
                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >7890987678</span>
                </span>
              </p>
            </div>
          </div>
          <!-- Invoice item table -->
          <div
            class="invoice-item-table"
            :style="{'border-top':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 '}"
          >
            <table>
              <thead>
                <th
                  v-if="field.item_prop.label.item_no.show"
                  :style="{'width':field.item_prop.label.item_no.width+'%','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','font-size':field.item_prop.layout.header_font_size +'pt !important','background-color':field.item_prop.layout.bg_color.show == 1?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex }"
                  style="display:table-cell;word-break: break-word !important"
                  class="text-left"
                >{{field.item_prop.label.item_no.label}}</th>
                <th
                  v-if="field.item_prop.label.item.show||field.item_prop.label.desc.show"
                  :style="{'width':(field.item_prop.label.item.show?field.item_prop.label.item.width:field.item_prop.label.desc.width)+'%','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','font-size':field.item_prop.layout.header_font_size +'pt !important','background-color':field.item_prop.layout.bg_color.show == 1?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex }"
                  style="display:table-cell;word-break: break-word !important"
                  class="text-left"
                >
                  <template
                    v-if="field.item_prop.label.item.show"
                  >{{field.item_prop.label.item.label+(field.item_prop.label.desc.show?field.item_prop.label.desc.label?(' & '+field.item_prop.label.desc.label):'& Description':'')}}</template>
                  <template v-else>{{field.item_prop.label.desc.label}}</template>
                </th>
                <th
                  :style="{'width':field.item_prop.label.hsn.width+'%','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','font-size':field.item_prop.layout.header_font_size +'pt !important','background-color':field.item_prop.layout.bg_color.show == 1?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex }"
                  v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc==0"
                  style="display:table-cell;word-break: break-word !important"
                  class="text-left"
                >{{field.item_prop.label.hsn.label}}</th>
                <th
                  v-if="field.item_prop.label.qty.show"
                  :style="{'width':field.item_prop.label.qty.width+'%','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','font-size':field.item_prop.layout.header_font_size +'pt !important','background-color':field.item_prop.layout.bg_color.show == 1?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex }"
                  style="display:table-cell;word-break: break-word !important"
                  class="text-right"
                >{{field.item_prop.label.qty.label}}</th>
                <th
                  v-if="field.item_prop.label.rate.show"
                  :style="{'width':field.item_prop.label.rate.width+'%','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','font-size':field.item_prop.layout.header_font_size +'pt !important','background-color':field.item_prop.layout.bg_color.show == 1?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex }"
                  style="display:table-cell;word-break: break-word !important"
                  class="text-right"
                >{{field.item_prop.label.rate.label}}</th>
                <th
                  v-if="field.item_prop.label.discount.show"
                  :style="{'width':field.item_prop.label.discount.width+'%','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','font-size':field.item_prop.layout.header_font_size +'pt !important','background-color':field.item_prop.layout.bg_color.show == 1?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex }"
                  style="display:table-cell;word-break: break-word !important"
                  class="text-right"
                >{{field.item_prop.label.discount.label}}</th>
                <th
                  v-if="field.item_prop.label.tax_amt.show || field.item_prop.label.tax.show"
                  :style="{'width':(field.item_prop.label.tax_amt.width) +'%','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','font-size':field.item_prop.layout.header_font_size +'pt !important','background-color':field.item_prop.layout.bg_color.show == 1?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex }"
                  style="display:table-cell;word-break: break-word !important"
                  class="text-right"
                >
                  <!-- {(field.item_prop.label.tax.show?field.item_prop.label.tax.label:field.item_prop.label.tax_amt.label)}} -->
                  IGST
                </th>

                <th
                  v-if="field.item_prop.label.amt.show"
                  :style="{'width':field.item_prop.label.amt.width+'%','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','font-size':field.item_prop.layout.header_font_size +'pt !important','background-color':field.item_prop.layout.bg_color.show == 1?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex }"
                  style="display:table-cell;word-break: break-word !important;min-width:25px"
                  class="text-right"
                >{{field.item_prop.label.amt.label}}</th>
              </thead>

              <tbody>
                <tr>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.item_no.show"
                    class="text-left"
                    style="display:table-cell;word-break: break-word !important"
                  >1</td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.item.show||field.item_prop.label.desc.show"
                    class="text-left"
                    style="display:table-cell;word-break: break-word !important"
                  >
                    <span v-if="field.item_prop.label.item.show">Bournvita</span>
                    <span
                      v-if="field.item_prop.label.desc.show"
                      style="display:block;word-break: break-word !important"
                      :style="{'font-size':field.item_prop.layout.item_font_size +'pt !important','color':field.item_prop.layout.item_font_color.hex +' !important'}"
                    >Bournvita,, is a brand of malted and chocolate malt drink mixes manufactured by Cadburys.</span>
                    <span
                      v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc"
                      style="display:block;word-break: break-word !important"
                      :style="{'font-size':field.item_prop.layout.item_font_size +'pt !important','color':field.item_prop.layout.item_font_color.hex +' !important'}"
                    >HSN/SAC Code : 12345</span>
                  </td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc==0"
                    class="text-left"
                    style="display:table-cell;word-break: break-word !important"
                  >12345</td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.qty.show"
                    class="text-right"
                    style="display:table-cell;word-break: break-word !important"
                  >
                    1
                    <span
                      style="display:block;word-break: break-word !important"
                      :style="{'font-size':field.item_prop.layout.item_font_size +'pt !important','color':field.item_prop.layout.item_font_color.hex +' !important'}"
                      v-if="field.item_prop.label.qty.show_unit"
                    >Nos</span>
                  </td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.rate.show"
                    class="text-right"
                    style="display:table-cell;word-break: break-word !important"
                  >3,000.00</td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.discount.show"
                    class="text-right"
                    style="display:table-cell;word-break: break-word !important"
                  >23.00</td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.tax_amt.show || field.item_prop.label.tax.show"
                    class="text-right"
                    style="display:table-cell;word-break: break-word !important"
                  >
                    <span
                      style="display:block"
                      class="d-block"
                      v-if="field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show"
                    >18.00</span>
                    <span
                      style="display:block"
                      v-if="field.item_prop.label.tax.show"
                      :style="{'color':field.item_prop.layout.item_font_color.hex +' !important','font-size':field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show?'6pt':''}"
                    >12%</span>
                  </td>

                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.amt.show"
                    class="text-right"
                    style="display:table-cell;word-break: break-word !important"
                  >2,930.00</td>
                </tr>
                <tr>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.item_no.show"
                    class="text-left"
                    style="display:table-cell;word-break: break-word !important"
                  >2</td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.item.show||field.item_prop.label.desc.show"
                    class="text-left"
                    style="display:table-cell;word-break: break-word !important"
                  >
                    <span v-if="field.item_prop.label.item.show">Bournvita</span>
                    <span
                      v-if="field.item_prop.label.desc.show"
                      style="display:block;word-break: break-word !important"
                      :style="{'font-size':field.item_prop.layout.item_font_size +'pt !important','color':field.item_prop.layout.item_font_color.hex +' !important'}"
                    >Bournvita,, is a brand of malted and chocolate malt drink mixes manufactured by Cadburys.</span>
                    <span
                      v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc"
                      style="display:block;word-break: break-word !important"
                      :style="{'font-size':field.item_prop.layout.item_font_size +'pt !important','color':field.item_prop.layout.item_font_color.hex +' !important'}"
                    >HSN/SAC Code : 12345</span>
                  </td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc==0"
                    class="text-left"
                    style="display:table-cell;word-break: break-word !important"
                  >12345</td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.qty.show"
                    class="text-right"
                    style="display:table-cell;word-break: break-word !important"
                  >
                    1
                    <span
                      style="display:block;word-break: break-word !important"
                      :style="{'font-size':field.item_prop.layout.item_font_size +'pt !important','color':field.item_prop.layout.item_font_color.hex +' !important'}"
                      v-if="field.item_prop.label.qty.show_unit"
                    >Nos</span>
                  </td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.rate.show"
                    class="text-right"
                    style="display:table-cell;word-break: break-word !important"
                  >3,000.00</td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.discount.show"
                    class="text-right"
                    style="display:table-cell;word-break: break-word !important"
                  >23.00</td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.tax_amt.show || field.item_prop.label.tax.show"
                    class="text-right"
                    style="display:table-cell;word-break: break-word !important"
                  >
                    <span
                      style="display:block"
                      class="d-block"
                      v-if="field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show"
                    >18.00</span>
                    <span
                      style="display:block"
                      v-if="field.item_prop.label.tax.show"
                      :style="{'color':field.item_prop.layout.item_font_color.hex +' !important','font-size':field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show?'6pt':''}"
                    >12%</span>
                  </td>

                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.amt.show"
                    class="text-right"
                    style="display:table-cell;word-break: break-word !important"
                  >2,955.00</td>
                </tr>
                <tr>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.item_no.show"
                    class="text-left"
                    style="display:table-cell;word-break: break-word !important"
                  >3</td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.item.show||field.item_prop.label.desc.show"
                    class="text-left"
                    style="display:table-cell;word-break: break-word !important"
                  >
                    <span v-if="field.item_prop.label.item.show">Bournvita</span>
                    <span
                      v-if="field.item_prop.label.desc.show"
                      style="display:block;word-break: break-word !important"
                      :style="{'font-size':field.item_prop.layout.item_font_size +'pt !important','color':field.item_prop.layout.item_font_color.hex +' !important'}"
                    >Bournvita,, is a brand of malted and chocolate malt drink mixes manufactured by Cadburys.</span>
                    <span
                      v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc"
                      style="display:block;word-break: break-word !important"
                      :style="{'font-size':field.item_prop.layout.item_font_size +'pt !important','color':field.item_prop.layout.item_font_color.hex +' !important'}"
                    >HSN/SAC Code : 12345</span>
                  </td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc==0"
                    class="text-left"
                    style="display:table-cell;word-break: break-word !important"
                  >12345</td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.qty.show"
                    class="text-right"
                    style="display:table-cell;word-break: break-word !important"
                  >
                    1
                    <span
                      style="display:block;word-break: break-word !important"
                      :style="{'font-size':field.item_prop.layout.item_font_size +'pt !important','color':field.item_prop.layout.item_font_color.hex +' !important'}"
                      v-if="field.item_prop.label.qty.show_unit"
                    >Nos</span>
                  </td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.rate.show"
                    class="text-right"
                    style="display:table-cell;word-break: break-word !important"
                  >3,000.00</td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.discount.show"
                    class="text-right"
                    style="display:table-cell;word-break: break-word !important"
                  >23.00</td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.tax_amt.show || field.item_prop.label.tax.show"
                    class="text-right"
                    style="display:table-cell;word-break: break-word !important"
                  >
                    <span
                      style="display:block"
                      class="d-block"
                      v-if="field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show"
                    >18.00</span>
                    <span
                      style="display:block"
                      v-if="field.item_prop.label.tax.show"
                      :style="{'color':field.item_prop.layout.item_font_color.hex +' !important','font-size':field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show?'6pt':''}"
                    >12%</span>
                  </td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.amt.show"
                    class="text-right"
                    style="display:table-cell;word-break: break-word !important"
                  >2,930.00</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Invoice total and tax details -->
          <template v-if="field.total_prop.label.show_total_sec">
            <div
              class="invoice-total-tax"
              :style="{'font-size':field.total_prop.layout.total_font_size +'pt !important','background-color':field.total_prop.layout.total_bg_color.show == 1?field.total_prop.layout.total_bg_color.value.hex:'#fff','color':field.total_prop.layout.total_font_color.hex }"
            >
              <div v-if="field.total_prop.label.show_total_qty" style="display:flow-root;">
                <p
                  class="float-left"
                  style="width:50%;word-break:break-word !important"
                >{{field.total_prop.label.item_in_total}}</p>
                <p
                  class="float-right text-right"
                  style="width:50%;word-break:break-word !important"
                >3</p>
              </div>
              <div
                v-if="field.total_prop.label.sub_total.show&&field.total_prop.label.show_total_sec"
                style="display:flow-root;"
              >
                <h6
                  class="float-left"
                  style="width:50%;word-break:break-word !important"
                  :style="{'font-size':field.total_prop.layout.total_font_size +'pt !important'}"
                >{{field.total_prop.label.sub_total.label}}</h6>
                <h6
                  class="float-right text-right"
                  style="width:50%;word-break:break-word !important"
                  :style="{'font-size':field.total_prop.layout.total_font_size +'pt !important'}"
                >7,017.00</h6>
              </div>
              <div
                v-if="field.total_prop.label.show_total_sec&&field.total_prop.label.show_discount"
                style="display:flow-root;"
              >
                <p class="float-left" style="width:50%;word-break:break-word !important">Discount</p>
                <p
                  class="float-right text-right"
                  style="width:50%;word-break:break-word !important"
                >(-) 183.00</p>
              </div>
              <div v-if="field.total_prop.label.show_total_sec" style="display:flow-root;">
                <p class="float-left" style="width:50%;word-break:break-word !important">IGST[12%]</p>
                <p
                  class="float-right text-right"
                  style="width:50%;word-break:break-word !important"
                >42.04</p>
              </div>

              <!-- <div v-if="field.total_prop.label.show_total_sec" style="display:flow-root;">
                <p class="float-left" style="width:50%;word-break:break-word !important">CGST[12%]</p>
                <p
                  class="float-right text-right"
                  style="width:50%;word-break:break-word !important"
                >42.04</p>
              </div>-->
              <div
                v-if="field.total_prop.label.show_total_sec && field.total_prop.label.shipping_charge"
                style="display:flow-root;"
              >
                <p
                  class="float-left"
                  style="width:50%;word-break:break-word !important"
                >{{field.total_prop.label.shipping_charge}}</p>
                <p
                  class="float-right text-right"
                  style="width:50%;word-break:break-word !important"
                >0.00</p>
              </div>

              <div v-if="field.total_prop.label.show_pay_detail" style="display:flow-root;">
                <h6
                  class="float-left"
                  style="width:50%;word-break:break-word !important"
                  :style="{'font-size':field.total_prop.layout.total_font_size +'pt !important'}"
                >{{field.total_prop.label.total}}</h6>
                <h6
                  :style="{'font-size':field.total_prop.layout.total_font_size +'pt !important'}"
                  class="float-right text-right"
                  style="width:50%;word-break:break-word !important"
                  v-if="field.total_prop.label.currency_syb == 1"
                >{{orgCurrencySymbol}} 7,259.04</h6>
                <h6
                  :style="{'font-size':field.total_prop.layout.total_font_size +'pt !important'}"
                  class="float-right text-right"
                  style="width:50%;word-break:break-word !important"
                  v-if="field.total_prop.label.currency_syb == 2"
                >7,259.04 {{orgCurrencySymbol}}</h6>
              </div>
              <div v-if="field.total_prop.label.show_pay_detail" style="font-style:italic">
                <div
                  v-if="field.menu_id == 1 &&field.total_prop.label.amt_withheld"
                  style="display:flow-root;"
                >
                  <p
                    class="float-left"
                    style="width:50%;word-break:break-word !important;"
                  >{{field.total_prop.label.amt_withheld}}</p>
                  <p
                    class="float-right text-right"
                    style="width:50%;word-break:break-word !important"
                  >0.00</p>
                </div>
                <div
                  v-if="field.menu_id == 1 &&field.total_prop.label.credits_apply"
                  style="display:flow-root;"
                >
                  <p
                    class="float-left"
                    style="width:50%;word-break:break-word !important"
                  >{{field.total_prop.label.credits_apply}}</p>
                  <p
                    class="float-right text-danger text-right"
                    style="width:50%;word-break:break-word !important"
                  >(-) 0.00</p>
                </div>
                <div
                  v-if="field.menu_id == 1 &&field.total_prop.label.pay_made"
                  style="display:flow-root;"
                >
                  <p
                    class="float-left"
                    style="width:50%;word-break:break-word !important"
                  >{{field.total_prop.label.pay_made}}</p>
                  <p
                    class="float-right text-danger text-right"
                    style="width:50%;word-break:break-word !important"
                  >(-) 0.00</p>
                </div>
                <div
                  v-if="field.menu_id == 1 &&field.total_prop.label.writeoff_amt_label"
                  style="display:flow-root;"
                >
                  <p
                    class="float-left"
                    style="width:50%;word-break:break-word !important"
                  >{{field.total_prop.label.writeoff_amt_label}}</p>
                  <p
                    class="float-right text-danger text-right"
                    style="width:50%;word-break:break-word !important"
                  >(-) 0.00</p>
                </div>
                <div
                  v-if="field.menu_id == 3 &&field.total_prop.label.refund"
                  style="display:flow-root;"
                >
                  <p
                    class="float-left"
                    style="width:50%;word-break:break-word !important"
                  >{{field.total_prop.label.refund}}</p>
                  <p
                    class="float-right text-right"
                    style="width:50%;word-break:break-word !important"
                  >(-) 0.00</p>
                </div>
                <div
                  v-if="field.menu_id == 3 &&field.total_prop.label.credits_used"
                  style="display:flow-root;"
                >
                  <p
                    class="float-left"
                    style="width:50%;word-break:break-word !important"
                  >{{field.total_prop.label.credits_used}}</p>
                  <p
                    class="float-right text-right"
                    style="width:50%;word-break:break-word !important"
                  >(-) 0.00</p>
                </div>
                <!-- <div
                  v-if="field.menu_id == 3 &&field.total_prop.label.credits_remaining"
                  style="display:flow-root;"
                >
                  <p class="float-left">{{field.total_prop.label.credits_remaining}}</p>
                  <p class="float-right">23.00</p>
                </div>-->
              </div>
            </div>
            <!-- Invoice grand total -->
            <div
              v-if="field.total_prop.label.show_pay_detail && field.menu_id != 3"
              class="grand-total"
              style="display:flow-root;background:#fff !important"
            >
              <h4
                class="float-left"
                style="width:50%;word-break:break-word !important"
              >{{field.total_prop.label.bal_due}}</h4>
              <h4 class="float-right text-right" style="width:50%;word-break:break-word !important">
                <span
                  :class="{'float-right':field.total_prop.label.currency_syb==2}"
                >{{orgCurrencySymbol}}</span> 7,859.04
              </h4>
            </div>
            <div
              v-else-if="field.total_prop.label.show_pay_detail && field.menu_id == 3"
              class="grand-total"
              style="display:flow-root;background:#fff !important"
            >
              <h4
                class="float-left"
                style="width:50%;word-break:break-word !important"
              >{{field.total_prop.label.credits_remaining}}</h4>
              <h4 class="float-right text-right" style="width:50%;word-break:break-word !important">
                <span
                  :class="{'float-right':field.total_prop.label.currency_syb==2}"
                >{{orgCurrencySymbol}}</span> 7,859.04
              </h4>
            </div>
            <div v-else class="grand-total" style="display:flow-root;background:#fff !important">
              <h4
                class="float-left"
                style="width:50%;word-break:break-word !important"
              >{{field.total_prop.label.total}}</h4>
              <h4 class="float-right text-right" style="width:50%;word-break:break-word !important">
                <span
                  :class="{'float-right':field.total_prop.label.currency_syb==2}"
                >{{orgCurrencySymbol}}</span> 7,859.04
              </h4>
            </div>
          </template>
          <!-- Invoice notes -->
          <div v-if="true" :style="{'color':field.temp_prop.font_color.hex}">
            <p class="invoice-notes text-center">Looking forward for your business</p>
          </div>
        </div>
        <!-- End of Body -->
        <!-- Footer block -->
        <div
          class="invoice-footer-block"
          :style="{'height':field.temp_prop.margin_bottom+'in'}"
          style="background:#fff"
        ></div>
      </div>
    </div>
    <!-- End -->
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import { mapGetters } from "vuex";
export default {
  props: ["list"],
  data() {
    return {
      field: JSON.parse(JSON.stringify(this.list)),
      imageSrc: ""
    };
  },
  methods: {
    preview(eve) {
      this.field = JSON.parse(JSON.stringify(eve));
    }
  },
  mounted() {
    EventBus.$on("preview", this.preview); // to trigger the method from parentcomponent
  },
  created() {
    this.imageSrc =
      this.org_details.org_logo != null && this.org_details.org_logo != ""
        ? `data:image/jpeg;base64,` + this.org_details.org_logo
        : "";
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapGetters(["org_details", "inv_settings_details", "orgCurrencySymbol"])
  }
};
</script>

<style lang="scss" scoped>
.clearfix:after,
.clearfix:before {
  content: " ";
  display: table;
}
.ribbon {
  position: absolute !important;
  top: -4px;
  left: -5px;
  overflow: hidden;
  width: 120px;
  height: 120px;
}

.ribbon .ribbon-inner {
  font-size: 13px;
  text-align: center;
  color: #fff;
  top: 34px;
  left: -35px;
  width: 166px;
  padding: 4px;
  position: relative;
  transform: rotate(-45deg);
}
.ribbon .ribbon-inner:before {
  left: 0;
  border-left: 2px solid transparent;
}
.ribbon .ribbon-inner:after {
  right: -2px;
  border-bottom: 3px solid transparent;
}
.ribbon .ribbon-inner:after,
.ribbon .ribbon-inner:before {
  content: "";
  border-top: 5px solid transparent;
  border-left: 5px solid;
  border-left-color: inherit;
  border-right: 5px solid transparent;
  border-bottom: 5px solid;
  border-bottom-color: inherit;
  position: absolute;
  top: 20px;
  transform: rotate(-45deg);
}
@font-face {
  font-family: "WebFont-Ubuntu";
  src: local(Ubuntu),
    url(https://fonts.gstatic.com/s/ubuntu/v10/4iCs6KVjbNBYlgoKcg72nU6AF7xm.woff2);
}
.details-container {
  position: relative;
  margin-bottom: 35px;
  box-shadow: 0 0 6px #ccc;
}

.pcs-template {
  font-family: Ubuntu, "WebFont-Ubuntu";
  font-size: 9pt;
  color: #000000;
  background: #ffffff;
}

.pcs-header-content {
  font-size: 9pt;
  color: #000000;
  background-color: #ffffff;
}
.pcs-template-body {
  padding: 0 0.2in 0 0.1in;
}
.pcs-template-footer {
  height: 0.1in;
  font-size: 6pt;
  color: #000000;
  padding: 0 0.2in 0 0.1in;
  background-color: #ffffff;
}
.pcs-footer-content {
  word-wrap: break-word;
  color: #000000;
  border-top: 1px solid #e3e3e3;
}

.pcs-label {
  color: #000000;
}
.pcs-entity-title {
  font-size: 28pt;
  color: #000000;
}
.pcs-orgname {
  font-size: 10pt;
  color: #000000;
  margin-bottom: 5px;
}
.pcs-customer-name {
  font-size: 9pt;
  color: #000000;
}
.pcs-itemtable-header {
  font-size: 9pt;
  color: #000000;
  background-color: #ffffff;
}
.pcs-itemtable-breakword {
  word-wrap: break-word;
}
.pcs-taxtable-header {
  font-size: 9pt;
  color: #000;
  background-color: #f5f4f3;
}
.itemBody tr {
  page-break-inside: avoid;
  page-break-after: auto;
}

.pcs-item-row {
  font-size: 8pt;
  border-bottom: 1px solid #e3e3e3;
  background-color: #ffffff;
  color: #000000;
}
.pcs-item-sku {
  margin-top: 2px;
  font-size: 10px;
  color: #444444;
}
.pcs-item-desc {
  color: #000000;
  font-size: 8pt;
}
.pcs-balance {
  background-color: #ffffff;
  font-size: 9pt;
  color: #000000;
}
.pcs-totals {
  font-size: 9pt;
  color: #000000;
  background-color: #ffffff;
}
.pcs-notes {
  font-size: 8pt;
}
.pcs-terms {
  font-size: 8pt;
}
.pcs-header-first {
  background-color: #ffffff;
  font-size: 9pt;
  color: #000000;
  height: auto;
}

.pcs-status {
  color: "";
  font-size: 15pt;
  border: 3px solid;
  padding: 3px 8px;
}
.billto-section {
  padding-top: 0mm;
  padding-left: 0mm;
}
.shipto-section {
  padding-top: 0mm;
  padding-left: 0mm;
}

@page :first {
  @top-center {
    content: element(header);
  }
  margin-top: 0.1in;
}

.pcs-template-header {
  padding: 0 0.2in 0 0.1in;
  height: 0.1in;
}

.pcs-template-fill-emptydiv {
  display: table-cell;
  content: " ";
  width: 100%;
}

/* Additional styles for RTL compat */

/* Helper Classes */

.inline {
  display: inline-block;
}
.v-top {
  vertical-align: top;
}
.text-align-right {
  text-align: right;
}
.rtl .text-align-right {
  text-align: left;
}
.text-align-left {
  text-align: left;
}
.rtl .text-align-left {
  text-align: right;
}

/* Helper Classes End */

.item-details-inline {
  display: inline-block;
  margin: 0 10px;
  vertical-align: top;
  max-width: 70%;
}

.total-in-words-container {
  width: 100%;
  margin-top: 10px;
}
.total-in-words-label {
  vertical-align: top;
  padding: 0 10px;
}
.total-in-words-value {
  width: 170px;
}
.total-section-label {
  padding: 5px 10px 5px 0;
  vertical-align: middle;
}
.total-section-value {
  width: 120px;
  vertical-align: middle;
  padding: 10px 10px 10px 5px;
}
.rtl .total-section-value {
  padding: 10px 5px 10px 10px;
}

.tax-summary-description {
  color: #727272;
  font-size: 8pt;
}
.itemBody td {
  padding: 0px !important;
  padding-left: 10px !important;
}
/* Overrides/Patches for RTL compat */
.rtl th {
  text-align: inherit; /* Specifically setting th as inherit for supporting RTL */
}
/* Overrides/Patches End */

.pcs-receipt-custom-header {
  height: 0.1in;
}
.pcs-receipt-custom-footer {
  height: 0.1in;
}
.pcs-receipt-header {
  text-align: center;
}
.pcs-item-row {
  border-bottom: none;
}
.pcs-itemtable-header {
  /* border-top: 1px dashed #3c3d3a; */
  border-bottom: 1px dashed #3c3d3a;
}
.pcs-balance td {
  border-top: 1px solid #3c3d3a;
  border-bottom: 1px solid #3c3d3a;
}
.pcs-receipt-header {
  padding: 0 0.2in 0 0.1in;
}
.rtl .pcs-receipt-header {
  padding: 0 0.1in 0 0.2in;
}
.pcs-receipt-body {
  padding: 0 0.2in 10px 0.1in;
}
.rtl .pcs-receipt-body {
  padding: 0 0.1in 10px 0.2in;
}
.pcs-receipt-body-fields {
  border-bottom: 1px dashed #3c3d3a;
  padding-top: 10px;
}
.pcs-receipt-body-field {
  /* width: 50%; */
  float: left;
  padding-bottom: 5px;
}
.rtl .pcs-receipt-body-field {
  float: right;
}
.itemBody tr:first-child td,
.pcs-totals tr:first-child td {
  padding-top: 5px !important;
}
.itemBody tr:last-child td,
.pcs-totals tr:last-child td {
  padding-bottom: 5px !important;
}
.pcs-balance {
  text-transform: uppercase;
  font-size: 14pt;
}
.pcs-itemheader-section {
  padding: 5px 0 5px 10px;
}
.rtl .pcs-itemheader-section {
  padding: 5px 10px 5px 0;
}
.pcs-lineitem-column {
  text-align: right;
  word-wrap: break-word;
}
.rtl .pcs-lineitem-column {
  text-align: left;
  word-wrap: break-word;
}
.pcs-itemvalue-section {
  padding-left: 10px !important;
}
.rtl .pcs-itemvalue-section {
  padding-right: 10px !important;
}
.details-container td {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.pr-0 {
  padding-right: 0px !important;
}
.pl-0 {
  padding-left: 0px !important;
}
.pcs-itemtable .pcs-itemtable-header {
  font-weight: 500 !important;
}
/* THERMAL PRINT CUSTOMIZE CSS */
/* // Bootstrap class */
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.semi-bold {
  font-weight: 500;
}
.bold {
  font-weight: 700;
}
.thermal-custom-invoice-address p,
.thermal-invoice-details {
  margin-bottom: 1px !important;
  font-size: 9pt;
}
.thermal-custom-invoice-address,
.thermal-invoice-details {
  // border-bottom: 1px dashed #000;
  margin-bottom: 5px;
}
.invoice-item-table {
  // border-top: 1px dashed #000;
}
.invoice-item-table table {
  width: 100% important;
  font-size: 9pt;
}
.invoice-item-table table td,
.invoice-item-table table th {
  padding: 5px !important;
  font-size: 8.5pt !important;
}
.invoice-item-table table > thead > th {
  // border-bottom: 1px dashed #000;

  padding-bottom: 5px;
}

.invoice-item-table table tr:last-child > td {
  border-bottom: 1px dashed #000;
}
.invoice-total-tax {
  margin-top: 5px;
  border-bottom: 1px solid #000;
}
.invoice-total-tax p {
  margin-bottom: 5px;
  // font-size: 9pt;
}
.grand-total {
  border-bottom: 1px solid #000;
}
.grand-total h4 {
  margin-top: 5px;
}
p.invoice-notes {
  font-size: 8pt !important;
  margin-top: 10px;
  margin-bottom: 0px;
}
#inch3-thermal-print-page {
  width: 3in;
  min-height: 6in;
}
#inch4-thermal-print-page {
  width: 4in;
  min-height: 6in;
}
#inch4-thermal-print-page .inch3-details-view,
#inch3-thermal-print-page .inch4-details-view {
  display: none;
}

@media (min-width: 768px) and (max-width: 1024px) {
  .responsive-print {
    zoom: 75%;
  }
}
@media (min-width: 1025px) and (max-width: 1440px) {
  .responsive-print {
    zoom: 95%;
  }
}
@media (min-width: 1441px) and (max-width: 2560px) {
  .responsive-print {
    zoom: 90%;
  }
}
</style>